import React from 'react';
import { Container, Card, CardGroup } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getAllProducts } from '../../store/products';
import { Link } from 'react-router-dom';
import { getProductTagline } from '../../utils/productCopy';
import PageHeading from '../PageHeading';

class AllProducts extends React.Component {
  componentDidMount() {
    this.props.getAllProducts();
  }
  render() {
    const products = this.props.products;
    if (!Array.isArray(products)) {
      return <h1>Loading</h1>;
    }
    return (
      <Container className="Center-column shop-products">
        {!this.props.filter && (
          <PageHeading icon="bag">Shop All Products</PageHeading>
        )}
        <CardGroup>
          {products.map((product) => {
            const tagline = getProductTagline(product.description);
            return (
              <Card
                key={product.id}
                border="light"
                className="text-center marg shop-product-card"
              >
                <Link to={'/product/' + product.id}>
                  <Card.Img
                    variant="top"
                    src={product.imgUrl}
                    alt={product.name}
                  />
                  <Card.Body>
                    <Card.Title>{product.name}</Card.Title>
                    {tagline && (
                      <Card.Text className="shop-product-tagline">
                        {tagline}
                      </Card.Text>
                    )}
                    <Card.Text className="shop-product-price">
                      ${product.price}
                    </Card.Text>
                  </Card.Body>
                </Link>
              </Card>
            );
          })}
        </CardGroup>
      </Container>
    );
  }
}

/**
 * CONTAINER
 */
const mapState = (state) => {
  return {
    products: state.products,
  };
};

const mapDispatch = (dispatch) => {
  return {
    getAllProducts: () => dispatch(getAllProducts()),
  };
};

export default connect(mapState, mapDispatch)(AllProducts);

/**
 * PROP TYPES
 */
AllProducts.propTypes = {
  products: PropTypes.object,
};
